import script from "./UserListing.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserListing.vue?vue&type=script&setup=true&lang=ts"

import "./UserListing.vue?vue&type=style&index=0&id=0007ba4c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0007ba4c"]])

export default __exports__